import { combineReducers } from 'redux';
import { SEARCH_INPUT, SEARCH_CLEAR } from './constants';
import { LOCATION_CHANGE } from 'react-router-redux/reducer';

const DEFAULT = '';

const input = (state = DEFAULT, action) => {
    switch (action.type) {
        case SEARCH_INPUT:
            return action.input;
        case LOCATION_CHANGE:
        case SEARCH_CLEAR:
            return DEFAULT;
        default:
            return state;
    }
};

export default combineReducers({ input });



// WEBPACK FOOTER //
// ./src/services/search/reducer.js